import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import { useStore } from './state/store';
import { getCurrentLayout } from './ui/ScoreView';
import { installErrorLog } from './app/errorLog';

installErrorLog();

// Test/debug hook: read-only access to the store from the console and e2e tests.
(window as unknown as { __simplenotation: unknown }).__simplenotation = { getState: useStore.getState, getLayout: getCurrentLayout };

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
